import React from 'react';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CmtCardFooter from '@coremat/CmtCard/CmtCardFooter';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { useHistory } from 'react-router';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import CmtCard from '@coremat/CmtCard';
import EventsRequests from 'services/events';

const useStyles = makeStyles(_ => ({
  cardContainer: {
    marginTop: 10,
  },
  dateText: {
    fontSize: 14,
  },
  assessmentInfoConatiner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  subtitle: {
    marginTop: 20,
    marginLeft: 5,
  },
  titleIcon: {
    marginRight: 8,
  },
  questionSubtitle: {
    margin: '10px 8px',
  },
}));

const EventElement = ({ data }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  let history = useHistory();
  const [openDialog, setOpenDialog] = useState(false);

  const editButtonHandler = () => {
    history.push(`/editEvent/${data._id}`);
  };

  const editSectionsHandler = () => {
    history.push(`/eventSections/${data._id}`);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };
  const handleRemoveAndClose = () => {
    setOpenDialog(false);
    dispatch(EventsRequests.removeSingleEvent(data._id));
  };

  return (
    <React.Fragment>
      <div className={classes.cardContainer}>
        <CmtCard>
          <CmtCardContent sx={{ pb: 0 }}>
            <Box className={classes.assessmentInfoConatiner}>
              <Box width={'100%'}>
                <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
                  <Typography variant="h3" color="textSecondary" component="h3">
                    {data.name}
                  </Typography>
                </Box>
                <Typography
                  color="textSecondary"
                  className={classes.subtitle}
                  dangerouslySetInnerHTML={{ __html: data.description }}></Typography>
              </Box>
            </Box>
            <br />
          </CmtCardContent>
          <CmtCardFooter separator={{ color: '#bdbdbd', borderWidth: 1, borderStyle: 'solid' }}>
            <Box>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<DeleteIcon />}
                onClick={() => setOpenDialog(true)}
                style={{ marginRight: 14, marginTop: 5 }}>
                حذف
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<EditIcon />}
                onClick={editButtonHandler}
                style={{ marginRight: 14, marginTop: 5 }}>
                ویرایش
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<EditIcon />}
                onClick={editSectionsHandler}
                style={{ marginRight: 14, marginTop: 5 }}>
                ویرایش سانس‌ها
              </Button>
            </Box>
          </CmtCardFooter>
        </CmtCard>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogContent>
          <DialogContentText id="alert-dialog-description">آیا از حدف این رخداد اطمینان دارید ؟</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRemoveAndClose} color="primary">
            تایید
          </Button>
          <Button onClick={handleClose} color="secondary" autoFocus>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default EventElement;
